import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import {
  CheckSvgIcn,
  EmailSvgIcn,
  WebsiteSvgIcn,
  CallSvgIcn,
  ClinksMemberSvgIcn,
  LocationSvgIcn,
  NoImgSvgIcn,
  MismatchMSvgIcn,
  SuccessMSvgIcn,
  NoclaimMSvgIcn,
  DownArrowSvgIcn,
  LeftArrowSvgIcn,
} from "svgIcon/index";
import { Card, Col, Modal, Row, Spinner } from "react-bootstrap";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaStar,
  FaArrowRight,
  FaPaperPlane,
} from "react-icons/fa";
import { agencyDetail } from "apiServices/app";
import { CLINKS_CLAIM_STATUS, DOMAIN_CLINKS } from "constants/app";
import AdditionalInformationComponents from "components/ClinksOrgDetails/AdditionalInformationComponents";
import ReviewsComponents from "components/ClinksOrgDetails/ReviewsComponents";
import { htmlParser, formatUrl, getStorageData } from "utils/helper";
import PathwayComponents from "../SearchInfoFieldsComponents/PathwayComponents";
import TargetGroupComponents from "../SearchInfoFieldsComponents/TargetGroupComponents";
import SearchCriteriaComponents from "../SearchInfoFieldsComponents/SearchCriteriaComponents";
import OrgDetailsSkeletonLoaderComponents from "../OrgDetailsSkeletonLoaderComponents";
import CarouselComponent from "components/FormsComponents/CarouselComponent";
import ButtonComponent from "components/FormsComponents/ButtonComponent";
import ClaimOrgModalComponent from "components/ModalComponents/ClaimOrgModalComponent";
import TextBoxComponent from "components/FormsComponents/TextBoxComponent";
import UpdateOrgModalComponent from "components/ModalComponents/UpdateOrgModalComponent";
const MainOrgDetailsComponent = (props) => {
  const { agency_id } = useParams();
  const navigate = useNavigate();
  const [clicksData, setClinksData] = useState();
  const [isModal, setIsModal] = useState(false);
  const [isUpdateModal, setIsUpdateModal] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [msgType, setMsgType] = useState("");
  const [isUpdate, setIsUpdate] = useState(false);
  const domain = getStorageData("domain");

  const getAgencyDetails = () => {
    let sourceToken = axios.CancelToken.source();

    agencyDetail({ agency_id: agency_id, is_all_data: true }, sourceToken)
      .then(({ data, success }) => {
        if (success === "true") {
          setClinksData(data);
        }
      })
      .catch((err) => {
        navigate("/");
      })
      .finally(() => {});
    return () => sourceToken.cancel();
  };

  useEffect(() => {
    getAgencyDetails();
  }, [agency_id]);

  return (
    <>
      {clicksData ? (
        <Row className="orgd__inner">
          <Col className="orgd__left" lg={9}>
            {window.innerWidth <= 991 && (
              <div
                class="d-lg-none d-flex align-items-center gap-2 mb-1 fw-semibold"
                onClick={() => {
                  navigate("/");
                }}
              >
                <LeftArrowSvgIcn />
                Back
              </div>
            )}
            <div className="orgd__content bg-white">
              <div className="orgd__conitems conitems__top d-flex flex-md-row flex-column align-items-md-start gap-3">
                <div className="orgd__title w-100 d-flex flex-column align-items-start position-relative">
                  <div className="orgd__tileft">
                    {clicksData?.name && (
                      <h3 className="mb-1 fw-bold text-dark">
                        {clicksData.name}
                      </h3>
                    )}
                    {clicksData?.office_address && (
                      <p className="mb-3 d-flex align-items-center">
                        <LocationSvgIcn className="me-1" />
                        <span className="text-gray">
                          {clicksData.office_address}
                        </span>
                      </p>
                    )}
                  </div>
                  {clicksData?.clinks_members &&
                  clicksData?.clinks_directory ? (
                    <div className="orgd__tiright bg-white rounded-pill d-flex align-items-center gap-1">
                      <ClinksMemberSvgIcn />
                      <p className="mb-0 text-brand-primary">
                        <small>
                          <small class="fw-500">Member</small>
                        </small>
                      </p>
                      {/* <CheckSvgIcn /> */}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="conitems__img">
                  {clicksData.image_data && clicksData.image_data.length ? (
                    <CarouselComponent data={clicksData} />
                  ) : clicksData.company_logo && clicksData.company_logo_url ? (
                    <Card.Img
                      variant="top"
                      src={clicksData.company_logo_url}
                      className="w-100 h-100 object-fit-contain"
                    />
                  ) : (
                    <div className="no__img p-3 bg-light text-center d-flex flex-column align-items-center justify-content-center gap-3">
                      <NoImgSvgIcn style={{ width: "40px", height: "40px" }} />
                      <span className="text-dark opacity-50 fw-medium">
                        The image associated with this organisation is not
                        visible.
                      </span>
                    </div>
                  )}
                </div>
              </div>
              {clicksData?.description && (
                <div className="orgd__conitems conitems__summary">
                  <h4 className="conitems__title text-dark fw-bold">Summary</h4>
                  <div className="summary__content">
                    <p className="text-gray">
                      {htmlParser(
                        clicksData.description.split("\n").join("<br />")
                      )}
                    </p>
                  </div>
                </div>
              )}
              {clicksData?.pathway_data?.length ? (
                <div className="orgd__conitems conitems__pathway">
                  <h4 className="conitems__title text-dark fw-bold">
                    Fields of work
                  </h4>
                  <PathwayComponents clicksData={clicksData} />
                </div>
              ) : (
                ""
              )}
              {clicksData?.target_group_data?.length ? (
                <div className="orgd__conitems conitems__targetgroup">
                  <TargetGroupComponents clicksData={clicksData} />
                </div>
              ) : (
                ""
              )}
              <SearchCriteriaComponents clicksData={clicksData} />
              {clicksData?.custom_tab?.length ? (
                <div className="orgd__conitems conitems__additionalinfo">
                  <AdditionalInformationComponents clicksData={clicksData} />
                </div>
              ) : (
                ""
              )}
            </div>
          </Col>
          <Col className="orgd__right mt-3 mt-lg-0" lg={3}>
            <div className="orgd__rbox bg-white">
              {clicksData?.contact_number ||
              clicksData?.email ||
              clicksData?.website_link ? (
                <div className="orgd__rcard">
                  <div className="orgd__contact d-flex flex-column">
                    {clicksData?.contact_number && (
                      <div className="orgd__coitems d-flex align-items-center gap-3">
                        <div className="coitems__icn d-flex align-items-center justify-content-center">
                          <CallSvgIcn
                            style={{ width: "16px", height: "16px" }}
                          />
                        </div>
                        <div className="coitems__content">
                          <small className="text-uppercase fw-normal">
                            Phone
                          </small>
                          <a
                            href={`tel:${clicksData?.contact_number}`}
                            className="mb-0 lh-1 text-dark fw-semibold d-block text-decoration-none"
                            title={clicksData?.contact_number}
                          >
                            {clicksData?.contact_number}
                          </a>
                        </div>
                      </div>
                    )}
                    {clicksData?.email && (
                      <div className="orgd__coitems d-flex align-items-center gap-3">
                        <div className="coitems__icn d-flex align-items-center justify-content-center">
                          <EmailSvgIcn
                            style={{ width: "17px", height: "13px" }}
                          />
                        </div>
                        <div className="coitems__content">
                          <small className="text-uppercase fw-normal">
                            Email address
                          </small>
                          <a
                            href={`mailto:${clicksData?.email}`}
                            className="mb-0 lh-1 text-dark fw-semibold d-block text-decoration-none"
                            title={clicksData?.email}
                          >
                            {clicksData?.email}
                          </a>
                        </div>
                      </div>
                    )}
                    {clicksData?.website_link && (
                      <div className="orgd__coitems d-flex align-items-center gap-3">
                        <div className="coitems__icn d-flex align-items-center justify-content-center">
                          <WebsiteSvgIcn
                            style={{ width: "17px", height: "17px" }}
                          />
                        </div>
                        <div className="coitems__content">
                          <small className="text-uppercase fw-normal">
                            Website
                          </small>
                          <a
                            href={formatUrl(clicksData.website_link)}
                            className="mb-0 lh-1 text-dark fw-semibold d-block text-decoration-none"
                            title={clicksData?.website_link}
                            target="_blank"
                          >
                            {clicksData?.website_link}
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
              {clicksData?.facebook_link ||
              clicksData?.twitter_link ||
              clicksData?.instagram_link ? (
                <div className="orgd__rcard">
                  <div className="orgd__social d-flex align-items-center justify-content-center gap-3">
                    {clicksData.facebook_link && (
                      <a
                        href={formatUrl(clicksData.facebook_link)}
                        className="social__items text-dark rounded-pill text-decoration-none d-flex align-items-center justify-content-center"
                        title="Facebook"
                        target="_blank"
                      >
                        <FaFacebook />
                      </a>
                    )}
                    {clicksData.twitter_link && (
                      <a
                        href={formatUrl(clicksData.twitter_link)}
                        className="social__items text-dark rounded-pill text-decoration-none d-flex align-items-center justify-content-center"
                        title="Twitter"
                        target="_blank"
                      >
                        <FaTwitter />
                      </a>
                    )}
                    {clicksData.instagram_link && (
                      <a
                        href={formatUrl(clicksData.instagram_link)}
                        className="social__items text-dark rounded-pill text-decoration-none d-flex align-items-center justify-content-center"
                        title="Instagram"
                        target="_blank"
                      >
                        <FaInstagram />
                      </a>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
              {clicksData?.is_admin === false ? (
                <div className="orgd__rcard">
                  <div className="orgd__social d-flex align-items-center justify-content-center gap-3">
                    <ButtonComponent
                      title="Claim Now"
                      onClick={() => setIsModal(true)}
                    >
                      Claim Now
                      <FaArrowRight className="ar__icn ms-2" />
                    </ButtonComponent>
                  </div>
                </div>
              ) : (
                domain === DOMAIN_CLINKS && (
                  <div className="orgd__rcard">
                    <div className="orgd__social d-flex align-items-center justify-content-center gap-3">
                      <ButtonComponent
                        title="Update Org"
                        onClick={() => setIsUpdateModal(true)}
                      >
                        Update Org
                        <FaArrowRight className="ar__icn ms-2" />
                      </ButtonComponent>
                    </div>
                  </div>
                )
              )}
            </div>
          </Col>
        </Row>
      ) : (
        <OrgDetailsSkeletonLoaderComponents />
      )}

      {isModal && (
        <ClaimOrgModalComponent
          showModal={isModal}
          setShowModal={setIsModal}
          isNoClaim={false}
          setShowSuccess={setShowSuccess}
          agencyId={clicksData?.agency_id}
          setMsgType={setMsgType}
        />
      )}

      {isUpdateModal && (
        <UpdateOrgModalComponent
          showModal={isUpdateModal}
          setShowModal={setIsUpdateModal}
          isNoClaim={false}
          setShowSuccess={setShowSuccess}
          agencyId={clicksData?.agency_id}
          setMsgType={setMsgType}
          setIsUpdate={setIsUpdate}
        />
      )}

      {showSuccess && (
        <Modal
          backdrop="static"
          className={`${
            CLINKS_CLAIM_STATUS.no_match === msgType
              ? "mismatchemail__modal"
              : "claimsuccess__modal"
          }`}
          show={showSuccess}
          onHide={() => setShowSuccess(false)}
        >
          <Modal.Body>
            <Modal.Header closeButton className="p-0 border-0"></Modal.Header>

            {isUpdate ? (
              CLINKS_CLAIM_STATUS.no_match === msgType ? (
                <div className="py-3 px-2">
                  <div className="d-flex flex-column align-items-center mb-4">
                    <div className="mmail__icn mismm__icn rounded-pill d-flex align-items-center justify-content-center mb-4">
                      <MismatchMSvgIcn />
                    </div>
                    <h5 className="mb-2 fw-bold text-dark text-center">
                      Update Unsuccessful: Email Mismatch
                    </h5>
                    <p className="mb-0 fw-normal text-center">
                      Your email address doesn't match the organisation's
                      registered website domain. For security reasons, we cannot
                      automatically grant access to update this record.
                    </p>
                  </div>
                  <div className="d-flex flex-column align-items-center justify-content-center gap-3">
                    <ButtonComponent
                      variant="dark"
                      onClick={() => setShowSuccess(false)}
                      title="Got it"
                      style={{ maxWidth: "150px" }}
                      className="w-100"
                    >
                      Got it
                    </ButtonComponent>
                  </div>
                </div>
              ) : CLINKS_CLAIM_STATUS.match === msgType ? (
                <div className="py-3 px-2">
                  <div className="d-flex flex-column align-items-center mb-4">
                    <div className="mmail__icn mismm__icn rounded-pill d-flex align-items-center justify-content-center mb-4">
                      <SuccessMSvgIcn />
                    </div>
                    <h5 className="mb-2 fw-bold text-dark text-center">
                      Success! Check Your Email
                    </h5>
                    <p className="mb-0 fw-normal text-center">
                      Please check your inbox for the link to update your
                      organisation. Make sure to check your spam or junk folder
                      if you don't see it right away!
                    </p>
                  </div>
                  <div className="d-flex flex-column align-items-center justify-content-center gap-3">
                    <ButtonComponent
                      variant="dark"
                      onClick={() => setShowSuccess(false)}
                      title="Got it"
                      style={{ maxWidth: "150px" }}
                      className="w-100"
                    >
                      Got it
                    </ButtonComponent>
                  </div>
                </div>
              ) : (
                ""
              )
            ) : CLINKS_CLAIM_STATUS.no_match === msgType ? (
              <div className="py-3 px-2">
                <div className="d-flex flex-column align-items-center mb-4">
                  <div className="mmail__icn mismm__icn rounded-pill d-flex align-items-center justify-content-center mb-4">
                    <MismatchMSvgIcn />
                  </div>
                  <h5 className="mb-2 fw-bold text-dark text-center">
                    Claim Unsuccessful: Email Mismatch
                  </h5>
                  <p className="mb-0 fw-normal text-center">
                    Your email address doesn't match the organisation's
                    registered website domain. For security reasons, we cannot
                    automatically grant access to claim this record.
                  </p>
                  <div className="py-4 d-flex justify-content-center w-100">
                    <div className="line" style={{ maxWidth: "120px" }}></div>
                  </div>
                  <h5 className="mb-1 fw-bold text-center">
                    Still need to claim it?
                  </h5>
                  <p className="mb-0 fw-normal text-center">
                    Please contact our support team at{" "}
                    <span className="fw-bold">support@clinks.org</span> and
                    we'll be happy to assist you manually.
                  </p>
                </div>
                <div className="d-flex flex-column align-items-center justify-content-center gap-3">
                  <ButtonComponent
                    variant="dark"
                    onClick={() => setShowSuccess(false)}
                    title="Got it"
                    style={{ maxWidth: "150px" }}
                    className="w-100"
                  >
                    Got it
                  </ButtonComponent>
                </div>
              </div>
            ) : CLINKS_CLAIM_STATUS.match === msgType ? (
              <div className="py-3 px-2">
                <div className="d-flex flex-column align-items-center mb-4">
                  <div className="mmail__icn mismm__icn rounded-pill d-flex align-items-center justify-content-center mb-4">
                    <SuccessMSvgIcn />
                  </div>
                  <h5 className="mb-2 fw-bold text-dark text-center">
                    Success! Check Your Email
                  </h5>
                  <p className="mb-0 fw-normal text-center">
                    Please check your inbox for the link to claim your
                    organisation. Make sure to check your spam or junk folder if
                    you don't see it right away!
                  </p>
                </div>
                <div className="d-flex flex-column align-items-center justify-content-center gap-3">
                  <ButtonComponent
                    variant="dark"
                    onClick={() => setShowSuccess(false)}
                    title="Got it"
                    style={{ maxWidth: "150px" }}
                    className="w-100"
                  >
                    Got it
                  </ButtonComponent>
                </div>
              </div>
            ) : (
              <div className="py-3 px-2">
                <div className="d-flex flex-column align-items-center mb-4">
                  <div className="mmail__icn mismm__icn rounded-pill d-flex align-items-center justify-content-center mb-4">
                    <NoclaimMSvgIcn />
                  </div>
                  <h5 className="mb-2 fw-bold text-dark text-center">
                    No Claim Available
                  </h5>
                  <p className="mb-0 fw-normal text-center">
                    You cannot claim this organisation because the claim option
                    is not available at this time.
                  </p>
                </div>
                <div className="d-flex flex-column align-items-center justify-content-center gap-3">
                  <ButtonComponent
                    variant="dark"
                    onClick={() => setShowSuccess(false)}
                    title="Got it"
                    style={{ maxWidth: "150px" }}
                    className="w-100"
                  >
                    Got it
                  </ButtonComponent>
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};
MainOrgDetailsComponent.propTypes = {
  history: propTypes.object,
};
export default MainOrgDetailsComponent;
